import React from 'react'
import styled from 'styled-components'
export default function LoadingAnimation({ lineWidth = 4 }) {
  return (
    <LoadingCSS lineWidth={lineWidth}>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </LoadingCSS>
  )
}
export const LoadingCSS = styled.div`
  display: inline-block;
  position: relative;
  width: 100%;
  height: 100%;
  & div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    border: ${(props) => props.lineWidth}px solid #fece37;
    border-radius: 50%;
    animation: circle-animation 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: #fece37 transparent transparent transparent;
  }

  & div:nth-child(1) {
    animation-delay: -0.45s;
  }
  & div:nth-child(2) {
    animation-delay: -0.3s;
  }
  & div:nth-child(3) {
    animation-delay: -0.15s;
  }
  @keyframes circle-animation {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`
